module.exports = __webpack_public_path__ + "img/rank-1.cd2a8810.svg";